export const SIGNUP_SOURCE_CLASS_NAMES = {
  marketingReferralSource: "MarketingReferralSource",
  user: "User",
} as const;

export const SIGNUP_SOURCE_HUMAN_READABLE_NAMES = {
  [SIGNUP_SOURCE_CLASS_NAMES.marketingReferralSource]: "referral source",
  [SIGNUP_SOURCE_CLASS_NAMES.user]: "user",
} as const;
